import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ValidationResponse } from '../../../../types/ValidationResponse';
import { updateOrder } from '../../../common/api/clients/order.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useEnquiryUpdate = () => {
    const queryClient = useQueryClient();

    return useMutation<
        Awaited<ReturnType<typeof updateOrder>>,
        AxiosError<ValidationResponse>,
        Parameters<typeof updateOrder>[0]
    >({
        mutationFn: updateOrder,
        onSuccess: (order) => {
            return queryClient.invalidateQueries({ queryKey: queries.orders.detail(order.id).queryKey });
        },
    });
};
